import {
  isItemLoading,
  isItemLoadingOrLoaded,
  LoadState,
} from '@trimble/data-loading';
import { ProjectDataState } from './DataStateModels';

export const isGaussianSplatLoading = (
  dataState: ProjectDataState,
  gaussianSplatId: string
): boolean => {
  if (dataState.gaussianSplat.state != LoadState.LoadComplete) {
    return false;
  }

  return isItemLoading(
    dataState.gaussianSplat.items[gaussianSplatId]?.loadState
  );
};

export const isGaussianSplatVisible = (
  dataState: ProjectDataState,
  gaussianSplatId: string
): boolean => {
  if (dataState.gaussianSplat.state != LoadState.LoadComplete) {
    return false;
  }

  const item = dataState.gaussianSplat.items[gaussianSplatId];
  if (item === undefined) {
    return false;
  }

  return isItemLoadingOrLoaded(item.loadState);
};

export const getVisibleGaussianSplatIds = (
  dataState: ProjectDataState
): string[] | undefined => {
  if (dataState.gaussianSplat.state != LoadState.LoadComplete) {
    return undefined;
  }

  return Object.keys(dataState.gaussianSplat.items).filter((id) => {
    return isGaussianSplatVisible(dataState, id);
  });
};
